// extracted by mini-css-extract-plugin
export default {"favoriteIcon":"SavedFiltersDrawer_favoriteIcon__gAO9x","avatar":"SavedFiltersDrawer_avatar__lGDwo","details":"SavedFiltersDrawer_details__x3FrA"};